// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iqep","label":"styles_label__3gYL8"};